<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title6"></a><div class="title-toc">Contents</div>
<p class="toc1"><a href="#/e9780806537351_fm01">Publisher’s Preface</a></p>
<p class="toc1"><a href="#/e9780806537351_c01">The Art of Rational Conjecture</a></p>
<p class="toc1"><span href="#/e9780806537351_c02" title="Link target outside of Sample">The Art of Drawing Inferences</span></p>
<p class="toc1"><span href="#/e9780806537351_c03" title="Link target outside of Sample">The Art of Reckoning</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780806537351_toc01.vue?1aa9d5a2